module.exports = __webpack_public_path__ + "img/Ayuda.b660de58.png";